import { TGetReportRequestForFieldIdData } from '../../types/mvpCharts';
import dayjs from 'dayjs';
import * as yup from 'yup';

export const FormInitialValue = {
  country: '',
  region: null,
  subRegion: null,
  village: null,
  cluster: null,
  regionManager: null,
  tpm: null,
  fa: null,
  organizer: null,
  farmType: null,
  cropType: null,
  hybridType: null,
  season: '',
  index: '',
  sowingStateDate: null,
  sowingEndDate: null,
};

export const formSchema = yup.object().shape({
  country: yup.string().nullable(),
  region: yup.string().nullable(),
  subRegion: yup.string().nullable(),
  village: yup.string().nullable(),
  cluster: yup.string().nullable(),
  // regionManager: yup.array().of(yup.string()).nullable(),
  // tpm: yup.array().of(yup.string()).nullable(),
  // fa: yup.array().of(yup.string()).nullable(),
  // organizer: yup.array().of(yup.string()).nullable(),
  regionManager: yup.string().nullable(),
  tpm: yup.string().nullable(),
  fa: yup.string().nullable(),
  organizer: yup.string().nullable(),
  farmType: yup.string().nullable(),
  cropType: yup.string().nullable(),
  hybridType: yup.string().nullable(),
  weeksOfSowing: yup.array(yup.number().nullable()),
  // hybridType: yup.array().of(yup.string()).nullable(),
  season: yup.string().nullable(),
  excludeHarvestFlag: yup.boolean(),
  excludePldFlag: yup.boolean(),
  index: yup
    .string()
    .required('Index ID is required')
    .nullable(),

  sowingStartDate: yup
    .string()
    .nullable()
    .test(
      'is-valid-range',
      'Please enter a number between 0 and 200',
      (value) => {
        if (!value) return true; // Allow nullable values
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0 && num <= 200;
      }
    )
    .test(
      'is-start-date-before-end-date',
      'Sowing start date must be less than or equal to sowing end date',
      function (value) {
        const { sowingEndDate } = this.parent; // Access other field values
        if (!value || !sowingEndDate) return true; // Allow nullable values
        const startDate = parseFloat(value);
        const endDate = parseFloat(sowingEndDate);
        if (isNaN(startDate) || isNaN(endDate)) return true; // Skip comparison if values aren't valid numbers
        return startDate <= endDate;
      }
    )
    .typeError('Please enter a valid number'),
  sowingEndDate: yup
    .string()
    .nullable()
    .test(
      'is-valid-range',
      'Please enter a number between 0 and 200',
      (value) => {
        if (!value) return true; // Allow nullable values
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0 && num <= 200;
      }
    )
    .test(
      'is-end-date-after-start-date',
      'Sowing end date must be greater than or equal to sowing start date',
      function (value) {
        const { sowingStartDate } = this.parent;
        if (!value || !sowingStartDate) return true; // Allow nullable values
        const endDate = parseFloat(value);
        const startDate = parseFloat(sowingStartDate);
        if (isNaN(startDate) || isNaN(endDate)) return true;
        return endDate >= startDate;
      }
    )
    .typeError('Please enter a valid number'),
});

export type MVPFormData = yup.InferType<typeof formSchema>;

export interface DropDownType {
  label: string;
  value: string;
}

export interface ListType {
  id: string;
  name: string;
  parentId?: string;
}

export const mapFormSchema = yup.object({
  dateOfData: yup.date().nullable(),
  farmNumbers: yup
    .array(yup.number().required())
    .max(6, 'You can select a maximum of 6 farms'),
  date: yup.string().default('CUSTOM_DATE'),
  intValue: yup
    .number()
    .min(0, 'Number must be at least 0')
    .max(200, 'Number cannot exceed 200')
    .typeError('Only numbers are allowed')
    .default(0),
});

const currDate = new Date();
export const cloudCoverFormSchema = yup.object({
  thresholdCover: yup
    .number()
    .required('Please enter threshold cover')
    .default(70)
    .max(70, 'Threshold cover should be between 0 to 70')
    .min(0, 'Threshold cover should be between 0 to 70')
    .typeError('Please enter a valid number'),
  startDate: yup
    .date()
    .default(dayjs(currDate).subtract(60, 'days').toDate())
    .required('Start Date is required'),
  endDate: yup
    .date()
    .default(dayjs(currDate).toDate())
    .required('End Date is required'),
});

export type MVPFiltersProps = {
  filterValues?: MVPFormData;
  fieldId?: number;
  dataa?: TGetReportRequestForFieldIdData;
  handleApplyFilter?: (values: MVPFormData) => void;
  filtersIsCollapsed?: boolean;
  dateOfData?: string;
  date?: string;
  intValue?: number;
  onNavigate?: (tabId: string, props?: any) => void; // 👈 add this
  showData?: boolean;
  onBack?: () => void;
  selectedIndex?: string;
  includeDatesList?: Array<string>;
  sowingTimeInSeconds?: number;
  havestTimeInSeconds?: number;
  type?: string;
  colums?: any;
  data?: any;
  tableDataType?: string;
  shouldFetchData?: boolean;
  debouncedIntValue?: number;
};

export const countryList = [
  { label: 'India', value: 'India' },
  { label: 'Thailand', value: 'Thailand' },
];

export type AllowedDayType = {
  day: number;
  indexTime: number;
};
